// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import {
  ParagraphComponent,
  SelectorRowComponent,
  CheckboxComponent,
} from '@openbank/ziniaweb-ui-components';
// Constants
import {
  KYC_LANDING_FEATURES_CONFIGURATION,
  KYC_LANDING_MODAL_CHILDREN_PARAGRAPH_PROPS,
  KYC_LANDING_MODAL_CONSENT_PROPS,
  KYC_LANDING_MODAL_CONSENT_CHECKBOX_PROPS,
  KYC_LANDING_MODAL_CONSENT_PARAGRAPH_PROPS,
} from './constants/kyc-landing.configuration.constants';
// Enums
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
// Styles
import { KycLandingModalConsentStyled } from '../kyc-landing.view.styled';
// Translations
import {
  KYC_LANDING_MODAL_BIZUM_DESCRIPTION,
  KYC_LANDING_MODAL_VIDEOCALL_DESCRIPTION,
} from '../translations/kyc-landing.translations';
// Types
import { KycLandingMethodsType } from '../types/kyc-landing-methods.type';
import {
  GetFeaturesKycConfigurationType,
  GetFeaturesKycConfigurationReturnType,
  GetModalChildrenConfigurationReturnType,
  GetModalChildrenConfigurationType,
} from './types/kyc-landing.configuration.type';

const getFeaturesKycConfiguration = ({
  methods,
}: GetFeaturesKycConfigurationType): GetFeaturesKycConfigurationReturnType[] =>
  methods.map(
    ({ type }: KycLandingMethodsType): GetFeaturesKycConfigurationReturnType =>
      Object.assign({ type }, KYC_LANDING_FEATURES_CONFIGURATION[type])
  );

const getModalChildrenConfiguration = ({
  handleOnChangeVideocallConsentHandler,
  selectedMethod,
  videocallConsent,
}: GetModalChildrenConfigurationType): GetModalChildrenConfigurationReturnType => {
  let children, disabled;

  switch (selectedMethod) {
    case KycMethodsEnumeration.BIZUM:
      children = (
        <ParagraphComponent {...KYC_LANDING_MODAL_CHILDREN_PARAGRAPH_PROPS}>
          <FormattedMessage id={KYC_LANDING_MODAL_BIZUM_DESCRIPTION} />
        </ParagraphComponent>
      );
      break;
    case KycMethodsEnumeration.VIDEOCALL:
      children = (
        <SelectorRowComponent
          {...KYC_LANDING_MODAL_CONSENT_PROPS}
          custom={{
            centerContent: (
              <KycLandingModalConsentStyled>
                <CheckboxComponent
                  {...{
                    ...KYC_LANDING_MODAL_CONSENT_CHECKBOX_PROPS,
                    value: videocallConsent.checked,
                  }}
                />
                <ParagraphComponent {...KYC_LANDING_MODAL_CONSENT_PARAGRAPH_PROPS}>
                  <FormattedMessage id={KYC_LANDING_MODAL_VIDEOCALL_DESCRIPTION} />
                </ParagraphComponent>
              </KycLandingModalConsentStyled>
            ),
          }}
          onClick={handleOnChangeVideocallConsentHandler}
        />
      );
      disabled = !videocallConsent.checked;
      break;
    case KycMethodsEnumeration.ACCOUNT_CHECK:
    default:
      children = '';
  }
  return { children, disabled };
};

export { getFeaturesKycConfiguration, getModalChildrenConfiguration };
